export default "__VITE_PUBLIC_ASSET__2defdc3a__"